import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            {/* <img src={logo} alt="Logo" /> */}
            <h2>KAVEESHA</h2>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/kaveesha-dhanasekara/" target="blank" style={{marginRight: '10px'}}><img src={navIcon1} alt="" /></a>
              <a href="https://github.com/AbstractLK" target="blank" style={{marginRight: '10px'}}><img src={navIcon2} alt="" /></a>
              <a href="https://medium.com/@kaveeshadhanasekara" target="blank"><img src={navIcon3} alt="" /></a>
            </div>
            <p>Copyright {currentYear}. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
